export const PATH_INDEX = '/';

export const PATH_SERVER_ERROR = '/500';

export const PATH_ADMIN = '/admin';
